import service from '@/screens/catalog-discount/assets/service.svg'
import tool from '@/screens/catalog-discount/assets/trade-in.svg'

// import wallet from '@/screens/catalog-discount/assets/wallet.png'
import { DocumentSvg } from '@/shared/lib/icons/iport/color/icons/document-svg'
import { Icon } from '@/shared/ui/icon'

// import { Image } from '@/shared/ui/Image'
import cl from '../../ui/product-main/product-triggers/product-triggers.module.scss'

const BENEFIT_ITEMS = [
	{
		type: 'icon' as const,
		icon: service,
		label: 'Гарантия 90 дней'
	},
	{
		type: 'icon' as const,
		icon: tool,
		label: 'Обмен в Трейд-ин'
	},
	{
		type: 'icon' as const,
		icon: DocumentSvg,
		label: 'Оплата по счёту для юр.лиц'
	}
	// {
	// 	type: 'image' as const,
	// 	src: wallet as unknown as string,
	// 	alt: 'Яндекс сплит',
	// 	label: 'Яндекс сплит'
	// }
]

export const DiscountBenefits = (): JSX.Element => (
	<ul className={cl.list}>
		{BENEFIT_ITEMS.map(item => (
			<li key={item.label} className={cl.item}>
				<Icon icon={item.icon} width={40} height={40} />
				{/* {item.type === 'icon' ? (
					<Icon icon={item.icon} width={40} height={40} />
				) : (
					<Image alt={item.alt} src={item.src} width={40} height={40} />
				)} */}
				<p>{item.label}</p>
			</li>
		))}
	</ul>
)
